var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0933 10.9291C18.1735 11.0093 18.2688 11.0729 18.3736 11.1164C18.4785 11.1598 18.5908 11.1821 18.7043 11.1821C18.8178 11.1821 18.9301 11.1598 19.035 11.1164C19.1398 11.0729 19.235 11.0093 19.3153 10.9291C19.3955 10.8488 19.4592 10.7536 19.5026 10.6487C19.546 10.5439 19.5684 10.4315 19.5684 10.3181C19.5684 10.2046 19.546 10.0922 19.5026 9.9874C19.4592 9.88257 19.3955 9.78731 19.3153 9.70708L10.6794 1.07115C10.5991 0.990858 10.5039 0.92716 10.3991 0.883701C10.2942 0.840241 10.1818 0.817872 10.0684 0.817872C9.95487 0.817872 9.84249 0.840241 9.73765 0.883701C9.63282 0.92716 9.53757 0.990858 9.45737 1.07115L0.82144 9.70708C0.659395 9.86912 0.568359 10.0889 0.568359 10.3181C0.568359 10.5472 0.659395 10.767 0.82144 10.9291C0.983485 11.0911 1.20327 11.1821 1.43243 11.1821C1.6616 11.1821 1.88138 11.0911 2.04342 10.9291L10.0684 2.90305L18.0933 10.9291Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandUp);
export default __webpack_public_path__ + "static/media/expandUp.0387909fc356f566a1655adab719ee29.svg";
export { ForwardRef as ReactComponent };